<style>

.bg{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-image: url("/i/signup-bg-wizard.jpg");
  background-size: cover;
  color: black;
  padding: 20px;
  overflow-y: scroll;
}

.margin{
  margin-top: 50px;
}

.list{
  position: fixed;
  top: 160px;
  left: 0;
  right: 0;
  bottom: 150px;
  z-index: 2;
  overflow-y: auto;
}

.item-container{
  width: 390px;
  margin: auto;
}

.item{
  display: grid;
  grid-template-columns: 40px auto;
  color: white;
  margin: 10px 40px 0 40px;
  padding: 10px 0;
}
.check{
  grid-column: 1;
  text-align: center;
}
.text{
  grid-column: 2;
}

button.show-all{
  border: none;
  background-color: rgba(255,255,255,0.5);
  color: black;
  width: auto;
  font-size: 20px;
}
button.show-all:hover{
  border: none;
  background-color: rgba(255,255,255,0.8);
  color: black;
}
.button-container{
  text-align: center;
  padding: 20px;
}

.looking-for{
  background-color: rgba(255,255,255,0.5);
  color: black;
}

.title-signup{
  margin-top: 50px;
}

</style>

<div class="bg">
  <div class="title-signup">Who are you looking to meet?</div>
  
  <div class="list" style="top: {showAll == true ? 110 : 160}px;">
    <div class="item-container">
    
      {#each lookingForOther as item}
        {#if showAllHelper(item, showAll)}
          <div class="item { lookingFor.includes(item.i) ? 'looking-for' : '' }" on:click="{ () => selectHelper(item.i) }">
            <div class="check">
              
              {#if lookingFor.includes(item.i)}
                <i class="icon-check"></i>
              {/if}
              
            </div>
            <div class="text">{item.t}</div>
          </div>
        {/if}
      {/each}
      
    </div>
    
    <div class="button-container">
      
      {#if !showAll}
        <button class="show-all" on:click="{ () => showAll = true }">Show All Identities</button>
      {/if}
    </div>
    
    <div class="margin small">Select all that apply</div>
    
  </div>
  
  <div class="has-buttons"></div>
</div>

<!-- <div class="next">
  <button on:click="{next}" disabled="{nextDisabled}">Next</button>
</div> -->
<NextButton on:click="{next}" disabled="{nextDisabled}"></NextButton>

<script>

import {push, pop, replace, location, link} from 'svelte-spa-router';

import Genders from "../../../../helpers/Genders.js";
const lookingForOther = Genders.lookingForOther;

import NextButton from "../../../../components/NextButton.svelte";

import Signup from "../../../../helpers/Signup.js";
import Validate from "../../../../helpers/Validate.js";

import { onMount } from "svelte";
onMount(async () => {
  try {
    Signup.verifyPersonalObject();
  } catch (e) {
    console.log("error:", e);
    
    if (e == "Must start from beginning") {
      document.location = "/";
    }
    
    return;
  }
  
  // if signup is already complete, then we push the user outta here...
  let signupComplete = Signup.getPersonalObject("signupComplete");
  if (signupComplete == true) {
    document.location = "/";
    return;
  }
  
  allowSignup = true;
  // Signup.saveToPersonalObject("lookingFor", "");
  lookingForSaved = Signup.getPersonalObject("lookingForSaved");
  lookingFor = Signup.getPersonalObject("lookingFor");
  
  // check if we need to show all identities aka the user selected genders
  // outside the default list
  
  for (let i in lookingForOther) {
    if ( lookingFor.includes( lookingForOther[i].i ) && lookingForOther[i].d == 0) {
      showAll = true;
      break;
    }
  }
  
  if (lookingForSaved == true) {
    nextDisabled = false;
  } else {
    check();
  }
  
});

let allowSignup = false;
let showAll = false;
let lookingFor = [];
let lookingForSaved = false;
let nextDisabled = true;


function selectHelper(item) {
  let index = lookingFor.indexOf(item);
  if (index != -1) {
    lookingFor.splice(index, 1);
  } else {
    lookingFor.push(item);
  }
  // console.log("lookingFor:", lookingFor);
  lookingFor = lookingFor;
  check();
}


function showAllHelper(item) {
  if (showAll == false && item.d == true) {
    return true;
  } else if (showAll == true) {
    return true;
  }
  
  return false;
}


function check() {
  lookingForSaved = false;
  try {
    Validate.allowSignup(allowSignup);
    Validate.isArrayFilled(lookingFor);
    nextDisabled = false;
  } catch (e) {
    nextDisabled = true;
    console.log("error:", e);
  }
}


async function next() {
  if (lookingForSaved == false) {
    await Signup.saveToPersonalObject("lookingFor", lookingFor);
    await Signup.saveToPersonalObject("lookingForSaved", true);
    await Signup.saveMe("lookingFor");
  }
  
  push("/signup/profile/personal/distance-away");
}


</script>